<template lang="pug">
  .dashboard.p-5
</template>

<script>
export default {
  name: 'Dashboard',
  computed: {
  },
};
</script>
